import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a1581a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "b-step1-detail-wrapper" }
const _hoisted_2 = { class: "list" }

import { ref, withDefaults, watch, computed } from "vue";
import Image from "@/components/Image.vue";
import type { File } from "@/types/index";


export default /*#__PURE__*/_defineComponent({
  props: {
    folwId: { default: 0 },
    detail: null
  },
  setup(__props: any) {

const props = __props as { folwId: number, detail: {
      PageFiles?: File[];
    } }


const uploadList = computed(() => {
  return props.detail.PageFiles;
});

return (_ctx: any,_cache: any) => {
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(uploadList), (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "list-item",
          key: index
        }, [
          _createVNode(_component_a_form, {
            style: {"display":"flex"},
            layout: "vertical"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form_item, {
                style: {"margin-right":"60px"},
                label: index == 0 ? '税务受理结果反馈单' : '申请税控设备回执单',
                required: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(Image, {
                    value: item.FileUrl,
                    "disable-close": true,
                    "file-type": item.AccessoryType,
                    "download-link": {
                filename:
                  index == 0
                    ? '税务受理结果反馈单.png'
                    : '申请税控设备回执单.png',
                fileKey: index == 0 ? '621' : '622',
              }
                  }, null, 8, ["value", "file-type", "download-link"])
                ]),
                _: 2
              }, 1032, ["label"])
            ]),
            _: 2
          }, 1024)
        ]))
      }), 128))
    ])
  ]))
}
}

})